import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

// Images
// import DivisionsImage from "../../../assets/divisions.png";

import { useGetStartedContext } from "context/GetStartedContextProvider";
import Button from "components/Button";
import Brands from "./Brands";
import Divisions from "./Divisions";

const HeroSection = () => {
  const { t } = useTranslation("home");
  const { handleModalChange } = useGetStartedContext();

  return (
    <div className="mt-[7rem] md:mt-[10rem]">
      <div className="flex justify-center items-center h-full">
        <div className="flex justify-center items-center md:w-[90%] w-[92%]">
          <div className="xl:w-[80%] flex justify-center items-center flex-col gap-5">
            <h2 className="text-[36px] md:text-[52px] font-semibold text-center font-lexend capitalize leading-[62px]">
              {t("header.title")}
            </h2>

            <p className="text-[#00000066] text-xl text-center md:w-[78%]">
              {t("header.description")}
            </p>
            <div className="flex justify-center items-center gap-5">
              <Button
                type="button"
                text={t("button.demo")}
                className="!px-10"
                size="sm"
                onClick={() => handleModalChange(true)}
              />
              <Link
                to="https://youtu.be/zjsAvAInW9Q?si=XHcznbIUBvLR1Yqy"
                target="_blank"
              >
                <Button
                  icon={
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.26388 0.314698L14.3713 5.36603C16.5429 6.45128 16.5429 9.54872 14.3713 10.634L4.26389 15.6853C2.30491 16.6643 0 15.2405 0 13.0513V2.94867C0 0.759506 2.3049 -0.664326 4.26388 0.314698Z"
                        fill="#202D66"
                      />
                    </svg>
                  }
                  variant={"outlined"}
                  text={t("button.knowUs")}
                  className="!px-10"
                  size="sm"
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-center items-center my-[5rem]">
        <Divisions />
      </div>
      <Brands />
    </div>
  );
};
export default HeroSection;
